import {
  LOGIN_SUCCESSFUL,
  MUST_ACCEPT_TAC,
  TWO_FACTOR_REQUIRED_ACCEPTED,
  TWO_FACTOR_REQUIRED_REQUESTED,
  PASSWORD_CHANGE_REQUIRED
} from '@api/Statuses'

import { mapGetters } from 'vuex'

export default {
  methods: {
    login({ userId, password, authToken, tokenMode }, params = {}, options = {}) {
      if (authToken) {
        this.authTokenVerify({ userId, password, authToken, tokenMode }, params, options)
      } else {
        this.userAuth({ userId, password }, params, options)
      }
    },
    userAuth ({ userId, password }, params = {}, options = {}) {
      this.$store.commit('CLEAR_ANNOUNCEMENT')

      return this.$store.dispatch('LOGIN', {
        body: { userId, password },
        params: params,
        options: options
      })
    },
    authTokenVerify ({ userId, password, authToken, tokenMode }, params = {}, options = {}) {
      this.$store.commit('CLEAR_ANNOUNCEMENT')

      return this.$store.dispatch('AUTH_TOKEN_VERIFY', {
        body: { userId, password, authToken, tokenMode },
        params: params,
        options: options
      })
    },
    requestToken(tokenMode = 'EMAIL') {
      this.requesting  = true
      this.$store.commit('CLEAR_ANNOUNCEMENT')
      return this.$store.dispatch('GET_NEW_TOKEN', {
        body: { userId: this.userId, tokenType: tokenMode }
      }).then((tokenStatus) => {
        this.requesting  = false
        if (tokenStatus) {
          this.showVerify = tokenStatus
        }
      })
    },
    loginWithSso () {
      this.$store.commit('CLEAR_ANNOUNCEMENT')
      return this.$store.dispatch('LOGIN_WITH_SSO', {
        body: {},
        params: {},
        options: {}
      })
    },
    loginWithRetries ({ userId, password }) {
      this.attemptCount++

      return this.login({ userId, password }, { autoLogin: true, attemptNumber: this.attemptCount }, { autoRedirect: false })
        .then(res => {
          if (!res) {
            this.retryLogin({ userId, password })
          } else {
            this.attemptCount = 0
          }
        })
        .catch((res) => {
          this.retryLogin({ userId, password })
        })
    },
    retryLogin({ userId, password }) {
      if (this.attemptCount >= this.maxAttempts) {
        this.attemptCount = 0

        // after trying to login the max retry attempt amount, just redirect to login page with the message the password was updated
        // as we're done automatically trying to log them in with retry attempts, they must login manually now
        this.$router.push({ name: 'login', params: { preventCacheBust: true, flashMessage: 'Password Updated' } })

        return
      }

      return new Promise((resolve) => setTimeout(resolve, 2000))
        .then(() => {
          return this.loginWithRetries({ userId, password })
        })
    }
  },
  data() {
    return {
      attemptCount: 0,
      maxRetries: 2,
      loginFlashMessage: '',
      showTokenOptions: false,
      showVerify: false,
      showPassword: false,
      requesting: false
    }
  },
  computed: {
    ...mapGetters([
      'loggingIn',
      'previousAttemptLoginUserId',
      'lockoutWarningCounter',
      'authFailed',
      'authErrorMessage',
      'authMessage',
      'authValue',
      'authStatus',
      'authError',
      'ssoAuthError',
      'tokenUserMessage',
    ]),
    maxAttempts() {
      return this.maxRetries + 1 // always 1 more than retries because attemps includes the initial
    },
    retryingLogin() {
      return this.attemptCount > 0
    },
  },
  watch: {
    'ssoAuthError' (newStatus, oldStatus) {
      if (newStatus === true) {
        this.$router.push({ name: 'sso-error' })
      }
    },
    'authStatus' (newStatus, oldStatus) {
      switch (newStatus) {
        case LOGIN_SUCCESSFUL:
          if (!this.$store.state.auth.termsAndConditionsAccepted) {
            this.$router.push({ name: 'terms' })
          } else {
            this.$router.push({ name: 'dashboard-prompt' })
          }
          break
        case MUST_ACCEPT_TAC:
          this.$router.push({ name: 'terms' })
          break
        case TWO_FACTOR_REQUIRED_REQUESTED :
          this.showTokenOptions = true
          break
        case TWO_FACTOR_REQUIRED_ACCEPTED:
          this.showVerify = true
          break
        case PASSWORD_CHANGE_REQUIRED:
          if (this.$store.state.auth.authValue && this.$store.state.auth.authValue.smsEnabled) {
            this.$router.push({ name: 'auth-choice' })
          } else {
            this.$router.push({ name: 'update-password' })
          }
          break
        default:
          // default assume failed login?
          this.$router.push({ name: 'login' })
          break
      }
    }
  }
}
